var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLeave = function SvgLeave(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 11,
    "data-width-16": 15,
    "data-width-20": 18,
    "data-width-24": 22,
    "data-width-28": 25,
    "data-width-72": 64,
    viewBox: "0 0 10.7 9.8",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.25 4.498H3.789l1.344-1.321a.365.365 0 0 0-.009-.512.38.38 0 0 0-.52-.01l-2 1.966a.363.363 0 0 0 0 .52l2 1.965a.38.38 0 0 0 .52-.009.365.365 0 0 0 .01-.511L3.758 5.234h6.492c.1 0 .195-.038.265-.108a.365.365 0 0 0 0-.52.38.38 0 0 0-.265-.108M0 1.375v7A1.375 1.375 0 0 0 1.375 9.75h1.5a.375.375 0 0 0 0-.75h-1.5a.625.625 0 0 1-.625-.625v-7A.625.625 0 0 1 1.375.75h1.5a.375.375 0 0 0 0-.75h-1.5A1.375 1.375 0 0 0 0 1.375",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLeave);
export default ForwardRef;